import axios from 'axios';
import React from 'react'
import { MdOutlineDelete } from "react-icons/md";
import { products_uri } from '../../../utils/url';
import { toast } from 'react-toastify';
import ProductMore from './product_more';
import ProdDelete from './Modal/delete';
import ProductPrice from './Modal/product_price';
import { PRICE_TYPE } from '../../../utils/types';
import ProductDetail from './Modal/productDetail';

const ProductCard = ({data, callback}) => {
  
  return (
    <div className='border rounded-md p-4 '>
      <div className='flex justify-between'>
        <div>
            <ProductDetail id={data.id} name={data.name}/>
            <h1 className='text-xs'>{data.price} ₮</h1>
        </div>
        <div>
            <ProdDelete callback={callback} data={data}/>
        </div>
      </div>
      <div className='mt-2'> 
        <ProductMore product={data}/>
        <div className='mt-2'></div>
        {
          data.price_many === PRICE_TYPE.Y &&
          <ProductPrice product={data}/>
        }
      </div>
    </div>
  )
}

export default ProductCard
